import { useEffect, useState } from 'react'

function useLoadableList<T>(fetchResults: (page: number) => Promise<T[]>) {
  const [results, setResults] = useState<T[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [canLoadMore, setCanLoadMore] = useState(false)
  const [, setPage] = useState(1)

  async function fetch(p: number) {
    setIsLoading(true)
    const response = await fetchResults(p)

    if (response.length) {
      setResults((r) => [...r, ...response])
      setCanLoadMore(true)
    } else {
      setCanLoadMore(false)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    setIsLoading(true)
    setResults([])
    setCanLoadMore(false)
    setPage(1)
    fetch(1)
  }, [fetchResults])

  function handleLoadMore() {
    if (!isLoading && canLoadMore) {
      setPage((p) => {
        fetch(p + 1)
        return p + 1
      })
    }
  }

  return {
    results,
    isLoading,
    onLoadMore: handleLoadMore,
  }
}

export default useLoadableList
